import React, { useEffect, useRef } from 'react';

interface Props {
  options?: boolean | ScrollIntoViewOptions;
}

export const ScrollHereOnce: React.FC<Props> = ({ options }) => {
  const anchorEl = useRef<HTMLDivElement>(null);
  const optionsRef = useRef(options);

  useEffect(() => {
    if (anchorEl && anchorEl.current) {
      anchorEl.current.scrollIntoView(optionsRef.current);
    }
  }, []);

  return <div ref={anchorEl} />;
};
